import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaServer, FaLaptop, FaCloud, FaShieldAlt, FaCode, FaTools } from 'react-icons/fa';
import './home.css';

const Home = () => {
    return (
        <div className="page-wrapper">
            {/* Hero Section */}
            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <img 
                            src={process.env.PUBLIC_URL + "/images/pc.webp"} 
                            alt="Custom PC" 
                            className="hero-image left" 
                        />
                        <div className="hero-text">
                            <h3>PC & Server Configuration Solutions</h3>
                            <p>Professional hardware and software solutions tailored to your needs</p>
                        </div>
                        <img 
                            src={process.env.PUBLIC_URL + "/images/server.webp"} 
                            alt="Server" 
                            className="hero-image right"
                        />
                    </div>
                </div>
            </section>
            
                        {/* Services Section */}
                        <section id="services" className="services section">
                <div className="container">
                    <h2 className="section-title">Our Services</h2>
                    <div className="slider-container">
                        <Slider
                            dots={true}
                            infinite={true}
                            speed={500}
                            slidesToShow={3}
                            slidesToScroll={1}
                            autoplay={true}
                            autoplaySpeed={3000}
                            responsive={[
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 1,
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1
                                    }
                                }
                            ]}
                        >
                            <div className="service-item">
                                <div className="service-icon">
                                    <FaLaptop />
                                </div>
                                <h3>PC Configuration</h3>
                                <p>i9 13900k processor</p>
                                <p>16GB/32GB RAM options</p>
                                <p>1TB NVMe SSD</p>
                                <p>8GB Graphics Card</p>
                                <p>27" 4K Monitor</p>
                                <p>amount: 50000</p>
                            </div>
                            <div className="service-item">
                                <div className="service-icon">
                                    <FaServer />
                                </div>
                                <h3>Server Configuration</h3>
                                <p>Dual Xeon Processors</p>
                                <p>64GB-256GB ECC RAM</p>
                                <p>10TB SSD Storage</p>
                                <p>1TB HDD Backup</p>
                                <p>Redundant PSU</p>
                                <p>amount: 50000</p>
                            </div>
                            <div className="service-item">
                                <div className="service-icon">
                                    <FaShieldAlt />
                                </div>
                                <h3>Security Solutions</h3>
                                <p>Enterprise Antivirus</p>
                                <p>Firewall Configuration</p>
                                <p>Network Security</p>
                                <p>Data Encryption</p>
                                <p>amount: 50000</p>
                            </div>
                            <div className="service-item">
                                <div className="service-icon">
                                    <FaCode />
                                </div>
                                <h3>Open Source</h3>
                                <p>Linux OS Installation</p>
                                <p>Open Source Tools</p>
                                <p>Custom Scripting</p>
                                <p>System Automation</p>
                            </div>
                            <div className="service-item">
                                <div className="service-icon">
                                    <FaCloud />
                                </div>
                                <h3>Cloud Solutions</h3>
                                <p>Cloud Migration</p>
                                <p>Hybrid Cloud Setup</p>
                                <p>Cloud Security</p>
                                <p>Backup Solutions</p>
                            </div>
                            <div className="service-item">
                                <div className="service-icon">
                                    <FaTools />
                                </div>
                                <h3>Maintenance</h3>
                                <p>System Updates</p>
                                <p>Performance Tuning</p>
                                <p>Hardware Upgrades</p>
                                <p>24/7 Support</p>
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section className="features section">
                <div className="container">
                    <h2 className="section-title">Why Choose Us</h2>
                    <div className="features-grid">
                        <div className="feature-card">
                            <div className="feature-icon">
                                <FaLaptop />
                            </div>
                            <h3>Custom PC Builds</h3>
                            <p>High-performance computers tailored to your specific needs and budget.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <FaServer />
                            </div>
                            <h3>Server Solutions</h3>
                            <p>Reliable server configurations for businesses of all sizes.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <FaShieldAlt />
                            </div>
                            <h3>Security</h3>
                            <p>Comprehensive security solutions to protect your systems.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* CTA Section */}
            <section className="cta">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Upgrade Your System?</h2>
                        <p>Contact us today for a free consultation and let us help you find the perfect solution for your needs.</p>
                        <a href="#contact" className="btn">Get Started</a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
